export const CONSTRAINT = "CONSTRAINT";
export const FORECAST = "FORECAST";
export const FORECAST_CURRENT = "FORECAST_CURRENT";
export const PLANNER_CURRENT = "PLANNER_CURRENT";
export const PLANNER_REQUESTED = "PLANNER_REQUESTED";
export const PLANNER_APPROVED = "PLANNER_APPROVED";
